import React from 'react'
import ItemsUnitListTable from './Components/ItemsUnitListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const ItemsUnitList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Unit Items List</HeadingOne>
          <AddItemBtn url="add-unit-items" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <ItemsUnitListTable />
      </div>
    </PageBody>
  );
};

export default ItemsUnitList;
